import { Container, Grid } from '@mui/material';
import { Fragment, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { SnackBar } from 'src/components/SnackBar';
import CarryForwardedLeavesView from './CarryForwardedLeavesView';

const CarryForwardedLeaves = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (Object.keys(user).length === 0) {
      navigate('/');
    }
  }, [navigate]);
  

  return (
    <>
      <Fragment>
        <Container maxWidth="lg">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={3}
          >
            <Grid item xs={12}>
            <CarryForwardedLeavesView />
            </Grid>
          </Grid>
          <SnackBar />
        </Container>
      </Fragment>
    </>
  );
};

export default CarryForwardedLeaves;
